import { BaseController } from '~/utils/base-controller';
import {
	createEditor,
} from '@knitiv/code-editor';
import angular from 'angular';

// const languageCompartment = new Compartment();
// const completionCompartment = new Compartment();
// const hoverCompartment = new Compartment();
// const linterCompartment = new Compartment();

/**
 * @typedef {import('@codemirror/state').Extension} Extension
 */

/**
 * @implements {angular.IController}
 */
export default class codeEditorController extends BaseController {
	/* @ngInject */
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 * @param {import('angular').IRootElementService} $element
	 */
	constructor($injector, $element) {
		super($injector);

		this.$element = $element;

		/** @type {boolean} */
		this.editable = true;

		/** @type {?import('@knitiv/code-editor').KnitivEditor} */
		this.editor = null;

		/** @type {?import('angular').INgModelController} */
		this.ngModelCtrl = null;
		this.ngModel = '';

		this.ref = null;

		this.placeholder = '';

		/**
		 * @param {{ editor: ReturnType<createEditor>}} [parameters]
		 */
		// eslint-disable-next-line no-unused-vars
		this.onEditorReady = parameters => {
			//
		};

		/**
		 * @returns {Extension[] | Promise<Extension[]>}
		 */
		this.onSetup = () => ([]);
	}

	/**
	 * @param {import('angular').IOnChangesObject} changes
	 */
	$onChanges(changes) {
		if (changes.ngModel) {
			const newState = this.ngModel;
			const previousState = this.editor?.view.state.doc.toString();

			if (newState !== previousState) {
				this.editor?.setContent(newState);
			}
		}
	}

	async $onInit() {
		const editor = this.$element.find('.editor').first().get(0);

		if (!editor) {
			throw new Error('No editor available!');
		}

		const extensions = [];

		if (this.onSetup && typeof this.onSetup === 'function') {
			const fetchedExtensions = await this.onSetup();
			if (fetchedExtensions && Array.isArray(fetchedExtensions)) {
				extensions.push(...fetchedExtensions);
			}
		}

		this.editor = createEditor({
			content: this.ngModel,
			extensions: [
				...extensions,
			],
			editable: this.editable ?? true,
			onUpdate: ({ value: newValue }) => {
				this.ngModelCtrl?.$setViewValue(newValue);
			},
		});

		editor?.append(this.editor.view.dom);

		this.onEditorReady({ editor: this.editor });
	}
}

// /**
//  * @param {EditorView} view
//  * @param language
//  */
// export function setlanguage(view, language) {
// 	view.dispatch({
// 		effects: languageCompartment.reconfigure(language),
// 	});
// }

// /**
//  * @param {EditorView} view
//  * @param completions
//  */
// export function setAutocompletions(view, completions) {
// 	view.dispatch({
// 		effects: completionCompartment.reconfigure(completions),
// 	});
// }

// /**
//  * @param view
//  * @param tooltips
//  */
// export function setTooltip(view, tooltips) {
// 	view.dispatch({
// 		effects: hoverCompartment.reconfigure(tooltips),
// 	});
// }

// /**
//  * @param view
//  * @param myLinter
//  */
// export function setLinter(view, myLinter) {
// 	view.dispatch({
// 		effects: linterCompartment.reconfigure(linter(myLinter)),
// 	});
// }
